import values from 'mout/object/values'

export default function concatAnswerStrings(answers) {
  return values(answers).map(a => a.answer).join('')
}



// WEBPACK FOOTER //
// ./src/helpers/content/concatAnswerStrings.js